module.exports = __webpack_public_path__ + "static/usa-heart-56f99c01bcdc42faaa91ca9a070b5a61.png";